import { Component, OnInit } from '@angular/core';
import { Input } from '@angular/core';
import { UserDataService } from '../../remote/data-storage/user-data.service';
import { AgoraRtmService } from '../services/agora-rtm.service';

@Component({
  selector: 'app-meeting-spot',
  templateUrl: './meeting-spot.component.html',
  styleUrls: ['./meeting-spot.component.scss']
})
export class MeetingSpotComponent implements OnInit {

  @Input()
  spotName: string;

  @Input()
  useId: number;

  @Input()
  connected: boolean;

  @Input()
  callsActions: any;

  @Input()
  isOwner: boolean;

  @Input()
  channelName: string;

  streamId:string;
  micStarted: boolean;

  constructor(private agoraRtmService: AgoraRtmService) { }

  ngOnInit(): void {
    this.streamId = this.channelName + '_local_' + this.useId;
  }

  startMic(){
    const messageObject = {
      user_id: this.useId,
      text: '',
      type: 'ACCEPT_HAND'
    };
    this.agoraRtmService.sendChannelMessage(JSON.stringify(messageObject), this.channelName)
        .then(r => {
          this.micStarted = true;
        });
  }

  closeMic(){
    const messageObject = {
      user_id: this.useId,
      text: '',
      type: 'REMOVE_HAND'
    };
    this.agoraRtmService.sendChannelMessage(JSON.stringify(messageObject), this.channelName)
        .then(r => {
          this.micStarted = false;
          this.callsActions.hand = false;
        });
  }

}
